export default "__VITE_ASSET__D99_84_R__"